// extracted by mini-css-extract-plugin
export var addButton = "_n1-0";
export var border = "_n1-8";
export var check = "_n1-h";
export var danger = "_n1-6";
export var dropdownContainer = "_n1-1";
export var editModalBody = "_n1-j";
export var footerContainer = "_n1-i";
export var fullWidth = "_n1-a";
export var hide = "_n1-9";
export var icon = "_n1-3";
export var input = "_n1-7";
export var inputFlex = "_n1-b";
export var inputWrapper = "_n1-c";
export var manualFocus = "_n1-5";
export var optionButton = "_n1-4";
export var pillWrapper = "_n1-e";
export var pointer = "_n1-2";
export var showOverflow = "_n1-f";
export var tagsFlex = "_n1-d";
export var xButton = "_n1-g";